import { render, staticRenderFns } from "./ReportByYearsExcel.vue?vue&type=template&id=485b3666"
import script from "./ReportByYearsExcel.vue?vue&type=script&lang=js"
export * from "./ReportByYearsExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports